import { lazyNamed } from 'src/utils/lazyNamed';

export const Positions = {
  PositionsList: lazyNamed(() => import('./containers/PositionsList'), 'PositionsList'),
};
